"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableHeaderSettingsModal = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("../bc-data-table-constants");
var BcDataTableHeaderSettingsModal = (function () {
    function BcDataTableHeaderSettingsModal(bcDataTableConfig) {
        this.bcDataTableConfig = bcDataTableConfig;
    }
    BcDataTableHeaderSettingsModal.prototype.createStructureModal = function () {
        return this._createArticleModal();
    };
    BcDataTableHeaderSettingsModal.prototype._createIconModal = function () {
        var divElement = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        var emElement = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        emElement.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS);
        emElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, 'true');
        emElement.innerHTML = 'hand';
        divElement.appendChild(emElement);
        return divElement;
    };
    BcDataTableHeaderSettingsModal.prototype._createSectionIconContainer = function () {
        var sectionElement = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.MODAL_ICON_CONTAINER);
        sectionElement.appendChild(this._createIconModal());
        return sectionElement;
    };
    BcDataTableHeaderSettingsModal.prototype._createSectionButtonClose = function () {
        var button = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
        button.classList.add(common_constants_1.BcCommonConstants.DIRECTION_ROW, common_constants_1.BcCommonConstants.ICONS_CLASS, bc_data_table_constants_1.BcDataTableConstansts.MODAL_CLOSE_BUTTON, common_constants_1.BcCommonConstants.ICON_SM_CLASS);
        button.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, 'Cerrar');
        button.innerHTML = common_constants_1.BcCommonConstants.ICON_ERROR;
        var sectionElement = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.MODAL_CLOSE_BUTTON_CONTAINER);
        sectionElement.appendChild(button);
        return sectionElement;
    };
    BcDataTableHeaderSettingsModal.prototype._createSectionModalTittle = function () {
        var h4Element = document.createElement(common_constants_1.BcCommonConstants.H4_TAG);
        h4Element.classList.add(bc_data_table_constants_1.BcDataTableConstansts.MODAL_TITLE_LABEL);
        h4Element.setAttribute(common_constants_1.BcCommonConstants.ID, "label-".concat(this.bcDataTableConfig.header.settings.modal.id));
        var title = this.bcDataTableConfig.header.settings.modal.title
            ? this.bcDataTableConfig.header.settings.modal.title
            : bc_data_table_constants_1.BcDataTableConstansts.TEXT_TITLE_MODAL;
        h4Element.innerHTML = title;
        var sectionElement = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.MODAL_TITLE, common_constants_1.BcCommonConstants.DIRECTION_ROW, common_constants_1.BcCommonConstants.MARGIN_TOP_2, common_constants_1.BcCommonConstants.MARGIN_BOTTOM_2);
        sectionElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABELLEDBY, "label-".concat(this.bcDataTableConfig.header.settings.modal.id));
        sectionElement.appendChild(h4Element);
        return sectionElement;
    };
    BcDataTableHeaderSettingsModal.prototype._createSectionDescription = function () {
        var divElement = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.TEXT_CENTER_CLASS);
        divElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_DESCRIPTION, bc_data_table_constants_1.BcDataTableConstansts.ARIA_DESCRIPTION_TEXT);
        var description = this.bcDataTableConfig.header.settings.modal.description
            ? this.bcDataTableConfig.header.settings.modal.description
            : bc_data_table_constants_1.BcDataTableConstansts.TEXT_DESCRIPTION_MODAL;
        divElement.innerHTML = description;
        var sectionElement = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.MODAL_CONTENT);
        sectionElement.appendChild(divElement);
        return sectionElement;
    };
    BcDataTableHeaderSettingsModal.prototype._sectionContainersButtons = function () {
        var applyText = this.bcDataTableConfig.header.settings.modal.applyButton
            ? this.bcDataTableConfig.header.settings.modal.applyButton
            : bc_data_table_constants_1.BcDataTableConstansts.TEXT_BUTTON_APPLY;
        var cancelText = this.bcDataTableConfig.header.settings.modal.cancelButton
            ? this.bcDataTableConfig.header.settings.modal.cancelButton
            : bc_data_table_constants_1.BcDataTableConstansts.TEXT_BUTTON_CANCEL;
        var buttonApply = this._createButton(applyText, 'primary');
        var buttonCancel = this._createButton(cancelText, 'secondary');
        var sectionElement = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.MODAL_BUTTON_CONTAINER);
        sectionElement.appendChild(buttonApply);
        sectionElement.appendChild(buttonCancel);
        return sectionElement;
    };
    BcDataTableHeaderSettingsModal.prototype._createButton = function (textContent, type) {
        var button = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
        button.classList.add("".concat(common_constants_1.BcCommonConstants.BC_BTN_CLASS, "-").concat(type), common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS);
        button.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTR_SIZEBUTTON, common_constants_1.BcCommonConstants.SMALL);
        button.innerHTML = textContent;
        return button;
    };
    BcDataTableHeaderSettingsModal.prototype._createSectionModal = function () {
        var sectionElement = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.MODAL_CONTAINER);
        sectionElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTR_CUSTOMWIDTH, common_constants_1.BcCommonConstants.MEDIUM);
        sectionElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTR_SUBTITLE, 'warning');
        sectionElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTR_BUTTONALIGNMENT, 'horizontal');
        sectionElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTR_TYPEICON, 'warning');
        sectionElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTR_ISCANCELLABLE, 'false');
        sectionElement.setAttribute(common_constants_1.BcCommonConstants.ROLE, 'alertdialog');
        sectionElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_MODAL, 'true');
        sectionElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, 'modal abierto');
        sectionElement.appendChild(this._createSectionButtonClose());
        sectionElement.appendChild(this._createSectionIconContainer());
        sectionElement.appendChild(this._createSectionModalTittle());
        sectionElement.appendChild(this._createSectionDescription());
        sectionElement.appendChild(this._sectionContainersButtons());
        return sectionElement;
    };
    BcDataTableHeaderSettingsModal.prototype._createArticleModal = function () {
        var articleElement = document.createElement('article');
        articleElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.MODAL_CLASS);
        articleElement.setAttribute(common_constants_1.BcCommonConstants.ROLE, 'dialog');
        articleElement.setAttribute(common_constants_1.BcCommonConstants.ID, this.bcDataTableConfig.header.settings.modal.id);
        articleElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABELLEDBY, "label-".concat(this.bcDataTableConfig.header.settings.modal.id));
        articleElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_MODAL, 'true');
        articleElement.appendChild(this._createSectionModal());
        return articleElement;
    };
    return BcDataTableHeaderSettingsModal;
}());
exports.BcDataTableHeaderSettingsModal = BcDataTableHeaderSettingsModal;
